import { createActions } from 'redux-actions';

export const { updateInfusionGuests } = createActions('UPDATE_INFUSION_GUESTS');
